/* eslint-disable */
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import styles from "./EditProfileForm.module.scss";
import {
  FormControl,
  Paper,
  TextField,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { connect } from "react-redux";
import { useNavigate } from "react-router";
import { getAllSystems } from "../../actions/system";
import { editCurrentUser } from "../../actions/users";
import Swal from "sweetalert2";

function EditProfileForm({
  enableEdit = false,
  currentUser = {},
  allSystems,
  getAllSystems,
  saveChangesTrigger = false,
  editCurrentUser,
  currentSystem,
  values = {
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    role: "agent",
    receiveEmails: { newTicket: false },
    systems: {},
  },
  setValues,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (getAllSystems) {
      getAllSystems();
    }
  }, []);

  useEffect(() => {
    if (!currentUser || !setValues) return;

    const systemNames =
      currentUser?.systems?.map((system) => system.name) || [];
    let initialSystems = {};

    if (systemNames && systemNames.length > 0) {
      initialSystems = {
        amarant: systemNames.some((name) => name?.includes("Amarant")),
        digidrive: systemNames.some((name) => name?.includes("DigiDrive")),
        enRpi: systemNames.some((name) => name?.includes("EnRPI")),
        fightScout: systemNames.some((name) => name?.includes("Fight Scout")),
        hydroPro: systemNames.some((name) => name?.includes("HydroPro")),
        immotech: systemNames.some((name) => name?.includes("Immotech")),
        motoza: systemNames.some((name) => name?.includes("Motoza")),
        ppa: systemNames.some((name) => name?.includes("PPA")),
        soCourt: systemNames.some((name) => name?.includes("SoCourt")),
        synergon: systemNames.some((name) => name?.includes("Synergon")),
        wink: systemNames.some((name) => name?.includes("Wink")),
        geowash: systemNames.some((name) => name?.includes("GeoWash")),
        "energy-retc": systemNames.some((name) => name?.includes("RETC")),
        "energy-op": systemNames.some((name) => name?.includes("Energy Op")),
        "energy-zagora": systemNames.some((name) =>
          name?.includes("Zagora Energy")
        ),
        "energy-proakt": systemNames.some((name) => name?.includes("Proakt")),
        "energy-energama": systemNames.some((name) =>
          name?.includes("Energama")
        ),
        "energy-ws": systemNames.some((name) => name?.includes("W&S Energy")),
      };
    }

    if (currentSystem?.constant) {
      initialSystems[currentSystem.constant] = true;
    }

    setValues({
      name: currentUser?.name || "",
      email: currentUser?.email || "",
      phoneNumber: currentUser?.phoneNumber || "",
      password: "",
      role: currentUser?.role || "agent",
      receiveEmails: currentUser?.receiveEmails || { newTicket: false },
      systems: initialSystems,
    });
  }, [currentUser?._id]);

  useEffect(() => {
    if (saveChangesTrigger === true && values) {
      const selectedSystems = Object.keys(values.systems || {}).filter(
        (system) => values.systems[system] === true
      );
      const parsedSystems = (allSystems || []).filter((system) =>
        selectedSystems.includes(system.constant)
      );
      const systemIdsArray = parsedSystems.map((system) => system._id);

      const payload = {
        _id: currentUser._id,
        name: values.name || currentUser.name || "",
        email: values.email || currentUser.email || "",
        phoneNumber: values.phoneNumber || currentUser.phoneNumber || "",
        role: values.role || currentUser.role || "agent",
        receiveEmails: values.receiveEmails ||
          currentUser.receiveEmails || { newTicket: false },
        systems: [...systemIdsArray],
      };

      if (values.password && values.password.trim() !== "") {
        payload.password = values.password;
      }

      editCurrentUser(payload);

      Swal.fire(t("app:profileUpdated"), "", "success").then(() => {
        try {
          if (currentSystem && currentSystem._id) {
            navigate(`/system/${currentSystem._id}/users`);
          } else {
            navigate("/users");
          }
        } catch (error) {
          console.error("Navigation error:", error);
          navigate("/");
        }
      });
    }
  }, [saveChangesTrigger]);

  const handleChange = (event, checkboxIdentifier = false) => {
    if (!event || !setValues || !values) return;

    try {
      if (checkboxIdentifier) {
        setValues((prevValues) => {
          const prevSystems = prevValues?.systems || {};
          return {
            ...prevValues,
            systems: {
              ...prevSystems,
              [event.target.name]: event.target.checked,
            },
          };
        });
      } else {
        setValues((prevValues) => ({
          ...prevValues,
          [event.target.name]: event.target.value,
        }));
      }
    } catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  const handleCheckBoxClick = (index, name) => {
    if (!setValues || !values || !name) return;

    try {
      setValues((prevValues) => {
        const newSystems = { ...(prevValues?.systems || {}) };
        newSystems[name] = !newSystems[name];
        return {
          ...prevValues,
          systems: newSystems,
        };
      });
    } catch (error) {
      console.error("Error in handleCheckBoxClick:", error);
    }
  };

  const safeValue = (path) => {
    if (!values) return "";

    if (path === "name") return values.name || "";
    if (path === "email") return values.email || "";
    if (path === "phoneNumber") return values.phoneNumber || "";
    if (path === "password") return values.password || "";
    if (path === "role") return values.role || "agent";

    return "";
  };

  const isSystemChecked = (constant) => {
    return values?.systems && values.systems[constant] === true;
  };

  const isReceiveEmailsChecked = () => {
    return values?.receiveEmails?.newTicket === true;
  };

  if (!values) {
    return <div>{t("loading")}</div>;
  }

  return (
    <Paper elevation={3} className={styles["form-container"]}>
      <div className={styles["heading-container"]}>
        <h3>{t("app:userData")}</h3>
      </div>
      <div className={styles["form-inputs"]}>
        <FormControl variant="outlined">
          <label htmlFor="name">{t("app:names")}</label>
          <TextField
            disabled={!enableEdit}
            className={styles["textfield"]}
            size="small"
            id="name"
            type="text"
            name="name"
            value={safeValue("name")}
            onChange={handleChange}
            style={{ maxWidth: "300px" }}
          />
        </FormControl>
        <FormControl variant="outlined">
          <label htmlFor="email">{t("app:email")}</label>
          <TextField
            disabled
            className={styles["textfield"]}
            id="email"
            size="small"
            name="email"
            type="email"
            value={safeValue("email")}
            onChange={handleChange}
            style={{ maxWidth: "300px" }}
          />
        </FormControl>
        <FormControl variant="outlined">
          <label htmlFor="phoneNumber">{t("app:phoneNumber")}</label>
          <TextField
            disabled={!enableEdit}
            className={styles["textfield"]}
            id="phoneNumber"
            size="small"
            name="phoneNumber"
            type="tel"
            value={safeValue("phoneNumber")}
            onChange={handleChange}
            placeholder="+359 888 123 456"
            style={{ maxWidth: "300px" }}
          />
        </FormControl>
        {enableEdit && (
          <FormControl variant="outlined">
            <label htmlFor="password">{t("app:newPassword")}</label>
            <TextField
              className={styles["textfield"]}
              id="password"
              size="small"
              type="text"
              name="password"
              value={safeValue("password")}
              onChange={handleChange}
              style={{ maxWidth: "300px" }}
            />
          </FormControl>
        )}
        <FormControl
          variant="outlined"
          style={{ width: "25%", paddingLeft: "30px" }}
          disabled={!enableEdit}
        >
          <label htmlFor="password">{t("app:role")}</label>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="radio-buttons-group"
            style={{ display: "flex", width: "100%", flexDirection: "row" }}
          >
            <FormControlLabel
              checked={values.role === "admin"}
              control={<Radio />}
              name={"role"}
              onChange={() => {
                setValues((prev) => ({ ...prev, role: "admin" }));
              }}
              label={t("app:admin")}
            />
            <FormControlLabel
              checked={values.role === "agent"}
              name={"role"}
              onChange={() => {
                setValues((prev) => ({ ...prev, role: "agent" }));
              }}
              control={<Radio />}
              label={t("app:agent")}
            />
          </RadioGroup>
        </FormControl>
      </div>
      <FormControl component={"fieldset"} variant="standard">
        <FormLabel component="legend">{t("app:systems")}</FormLabel>
        {enableEdit === true ? (
          <FormGroup className={styles["form-checkboxes"]}>
            {allSystems.map((system, index) => (
              <FormControlLabel
                key={index}
                sx={{ ml: "5px" }}
                control={
                  <div
                    className={styles["outer-checkbox"]}
                    onClick={() => handleCheckBoxClick(index, system.constant)}
                    style={{
                      borderColor: isSystemChecked(system.constant)
                        ? "#0DC1CE"
                        : "#000",
                    }}
                  >
                    <div
                      className={`${styles["inner-checkbox"]} ${
                        isSystemChecked(system.constant) && styles["show"]
                      } `}
                    />
                  </div>
                }
                label={
                  <p
                    onClick={() => handleCheckBoxClick(index, system.constant)}
                  >
                    {system.name}
                  </p>
                }
              />
            ))}
          </FormGroup>
        ) : (
          <b style={{ marginTop: "0.3%" }}>
            {currentUser?.systems?.map((system) => system.name).toString() +
              "\n"}
          </b>
        )}
      </FormControl>
      <FormControl
        variant="outlined"
        style={{ width: "100%" }}
        disabled={!enableEdit}
      >
        <label htmlFor="password">{t("app:receiveEmails")}</label>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="female"
          name="radio-buttons-group"
          style={{ display: "flex", width: "100%", flexDirection: "row" }}
        >
          <FormControlLabel
            checked={isReceiveEmailsChecked()}
            control={<Radio />}
            name={"receiveEmails"}
            onChange={() => {
              setValues((prev) => ({
                ...prev,
                receiveEmails: {
                  newTicket: true,
                },
              }));
            }}
            label={t("app:always")}
          />
          <FormControlLabel
            checked={!isReceiveEmailsChecked()}
            name={"receiveEmails"}
            onChange={() => {
              setValues((prev) => ({
                ...prev,
                receiveEmails: {
                  newTicket: false,
                },
              }));
            }}
            control={<Radio />}
            label={t("app:ifAssigned")}
          />
        </RadioGroup>
      </FormControl>
    </Paper>
  );
}

const mapStateToProps = (state) => ({
  allSystems: state.systems.allSystems,
});

const mapDispatchToProps = (dispatch) => ({
  getAllSystems: () => dispatch(getAllSystems()),
  editCurrentUser: (payload) => dispatch(editCurrentUser(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditProfileForm);
